import { gql } from '@apollo/client';
import BaseService from './baseService';

class ConfigurationSservice extends BaseService {
  constructor() {
    super();
    this.configurationGql = `
      config
    `;
  }

  getSettings = (search, collection) => new Promise((resolve, reject) => {
    const SETTINGS = gql`
      query Setting($search: JSON, $collection: String){
         settings(search:$search, collection:$collection)
      }
    `;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: SETTINGS,
        variables: {
          search,
          collection
        }
      })
      .then((result) => {
        if (result.data.settings) {
          resolve(result.data.settings);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  addSettings = (data, collection) => new Promise((resolve, reject) => {
    const SETTINGS = gql`
    mutation  Setting($data: JSON, $collection: String){
         addSetting(data:$data, collection:$collection)
    }`;

    this.client
      .mutate({
        mutation: SETTINGS,
        variables: {
          data,
          collection
        }
      })
      .then((result) => {
        if (result.data.addSetting) {
          resolve(result.data.addSetting);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  updateSettings = (data, collection) => new Promise((resolve, reject) => {
    const SETTINGS = gql`
    mutation  Setting($data: JSON, $collection: String){
      updateSetting(data:$data, collection:$collection)
    }`;

    this.client
      .mutate({
        mutation: SETTINGS,
        variables: {
          data,
          collection
        }
      })
      .then((result) => {
        if (result.data.updateSetting) {
          resolve(result.data.updateSetting);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  deleteSettings = (id, collection) => new Promise((resolve, reject) => {
    const SETTINGS = gql`
    mutation  Setting($id: String, $collection: String){
      deleteSetting(id:$id, collection:$collection)
    }`;

    this.client
      .mutate({
        mutation: SETTINGS,
        variables: {
          id,
          collection
        }
      })
      .then((result) => {
        if (result.data.deleteSetting) {
          resolve(result.data.deleteSetting);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  getConfigurations = (search) => new Promise((resolve, reject) => {
    const CONFIGURATIONS = gql`
      query Configuration($search: JSON){
         configurations(search:$search)
      }
    `;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: CONFIGURATIONS,
        variables: search ? { search } : { search: {} }
      })
      .then((result) => {
        if (result.data.configurations) {
          resolve(result.data.configurations);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  addConfiguration = (config) => new Promise((resolve, reject) => {
    const CONFIGURATIONS = gql`
    mutation  Configuration($config: JSON){
      addConfiguration(config:$config)
    }`;

    this.client
      .mutate({
        mutation: CONFIGURATIONS,
        variables: { config }
      })
      .then((result) => {
        if (result.data.addConfiguration) {
          resolve(result.data.addConfiguration);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  updateConfiguration = (config) => new Promise((resolve, reject) => {
    const CONFIGURATIONS = gql`
    mutation Configuration($config: JSON){
      updateConfiguration(config:$config)
    }`;

    this.client
      .mutate({
        mutation: CONFIGURATIONS,
        variables: { config }
      })
      .then((result) => {
        if (result.data.updateConfiguration) {
          resolve(result.data.updateConfiguration);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  removeConfiguration = (id) => new Promise((resolve, reject) => {
    const CONFIGURATIONS = gql`
    mutation Configuration($id: String){
      deleteConfiguration(Id:$id)
    }`;

    this.client
      .mutate({
        mutation: CONFIGURATIONS,
        variables: { id }
      })
      .then((result) => {
        if (result.data.deleteConfiguration) {
          resolve(result.data.deleteConfiguration);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });
}

const contactMethodsService = new ConfigurationSservice();

export default contactMethodsService;
